import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
} from "antd";
import {
  PlusOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
const { TextArea } = Input;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const TransactionProjectTypeUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const onSuccess = () => {
    form.resetFields();

    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    RequestHandler.put(`/TransactionProjectType`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    }).catch(function (error) {
      setLoading(false);
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="TransactionProjectTypeUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            label= {`${props.formTitle} Adı`}
            name="name"
            rules={[
              { required: true, message: `Lütfen ${props.formTitle} adını boş bırakmayın.` },
            ]}
          >
            <TextArea rows={3} />
          </Form.Item>
          <Form.Item
            label= {`${props.formTitle} Kodu`}
            name="projectCode"
            rules={[
              {
                required: true,
                message: `Lütfen ${props.formTitle} Kodu alanını boş bırakmayın.`,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Row justify="space-between">
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}></Col>
            <Col span={6}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default TransactionProjectTypeUpdateForm;
